/* eslint-disable */
import cx from 'classnames';
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas, setToken } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import { Elements, StripeProvider, CardElement, injectStripe } from 'react-stripe-elements';
import FontAwesome from 'react-fontawesome';

import OzComponent from '../lib/OzComponent';
import Wrapper from './Wrapper';
import './ProBooking.css';
import Loading from './partials/Loading';
import OzModalButton from './partials/OzModalButton';
import BookableSlotForm from './partials/BookableSlotForm';
import BookChargeForm from './partials/BookChargeForm';
import {
  register,
  fetchUser,
  getBookableSlot,
  updateBookableSlot,
  bookChargeAuth,
} from '../actions';


class ProBooking extends OzComponent {

  state = {};

  static need = [
    ['user', fetchUser],
    ['bookableSlot', getBookableSlot, p => p.id],
  ];

  componentDidMount() {
    this.refresh();
  }

  refresh() {
    this.setState({ loading: true });
    return this.props.getBookableSlot(this.props.params.id, { silent: true, background: true })
      .then(resp => {
        this.setState({ loading: false });
      });
  }

  renderBookableSlot() {
    let bookableSlot = this.props.bookableSlot;
    if (!bookableSlot) return;

    let nodes = bookableSlot.bookingActivities.map(ba => {
      return (
        <div className="booking-activity" key={ba.id}>
          <div className="meta">
            <div className="username">{ba.user.username}</div>
            <div className="timestamp">{moment(ba.timeCreated).fromNow()}</div>
          </div>
          <div className="text">{ba.text}</div>
        </div>
      );
    });

    return (
      <div className="bookable-slot">
        <div className="bookable-slot-info">
          <div className="room-name">{bookableSlot.room.name}</div>
          <div className="time-range">{bookableSlot.prettyStart}-{bookableSlot.prettyEnd}</div>
          <div className="status">
            <div className={cx('status-inner', bookableSlot.workflow)}>
              {bookableSlot.workflow}
            </div>
          </div>
          <div className="slots-left">{bookableSlot.slotsBooked}/{bookableSlot.totalSlots} slots booked</div>
        </div>

        <div className="booking-activities-wrapper">
          <div className="header">Activity</div>
          <div className="booking-activities">
            {nodes}
            {nodes.length == 0 && 'No activity yet'}
          </div>
        </div>
      </div>
    );
  }

  save(e, values) {
    let bookableSlot = this.props.bookableSlot;
    this.props.updateBookableSlot(bookableSlot.id, values)
      .then(resp => {
        if (resp.error) return;
        this.setState({ editing: false });
      });
  }

  bookCharge(e, values) {
    let bookableSlot = this.props.bookableSlot;
    values.bookableSlotId = bookableSlot.id;
    this.props.bookChargeAuth(values)
      .then(resp => {
        if (resp.error) return;
        this.refresh()
          .then(() => {
            this.setState({ booking: false });
          });
      });
  }

  renderControls() {
    let bookableSlot = this.props.bookableSlot;
    if (!bookableSlot) return;

    return (
      <div className="control-header">
        <div className="controls">
          <OzModalButton
            modalTitle="Book/Charge Payment"
            show={this.state.booking}
            onShow={() => this.setState({ booking: true })}
            onHide={() => this.setState({ booking: false })}
            >
            <Button>Book/Charge Payment</Button>

            <Elements>
              <BookChargeForm
                modal={true}
                values={{}}
                errors={this.props.errors.bookCharge}
                onCancel={() => this.setState({ booking: false })}
                onSubmit={(e, values) => this.bookCharge(e, values)}
                buttonText="Save"
                cancelText="Cancel"
                bookableSlot={bookableSlot}
              />
            </Elements>
          </OzModalButton>{' '}

          <OzModalButton
            modalTitle="Edit Booking"
            show={this.state.editing}
            onShow={() => this.setState({ editing: true })}
            onHide={() => this.setState({ editing: false })}
            >
            <Button>Make Changes</Button>

            <BookableSlotForm
              modal={true}
              values={bookableSlot}
              errors={this.props.errors.bookableSlot}
              onCancel={() => this.setState({ editing: false })}
              onSubmit={(e, values) => this.save(e, values)}
              buttonText="Save"
              cancelText="Cancel"
              bookableSlot={bookableSlot}
            />
          </OzModalButton>{' '}

          <Button onClick={() => this.refresh()}>Refresh</Button>
        </div>
      </div>
    );
  }

  render() {
    return (
      <Wrapper className="ProBooking" padded pro>
        <div className="pro-header">Manage Booking</div>

        {this.renderControls()}
        
        {this.state.loading && <Loading />}
        {!this.state.loading && this.renderBookableSlot()}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
    bookableSlot: state.get.bookableSlot,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    getBookableSlot,
    updateBookableSlot,
    bookChargeAuth,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProBooking);



/** WEBPACK FOOTER **
 ** ./src/components/ProBooking.js
 **/